import Title from '@/components/Form/Title'

import { ModalMinutaProps } from './Modal.type'

const ModalMinuta = ({ handleSendData }: ModalMinutaProps) => (
  <>
    <dialog id="minuta_modal" className="modal">
      <div className="modal-box w-11/12 max-w-5xl px-3 pb-3 pt-4">
        {/* Botão X para fechar o modal */}
        <form method="dialog">
          <button className="btn btn-circle btn-ghost btn-sm absolute right-2 top-2">✕</button>
        </form>

        {/* Conteúdo do modal */}
        <Title title="Pré Visualização da Minuta" />

        <iframe
          src="/minuta.pdf#zoom=100"
          width="100%"
          height="100%"
          className="mb-4"
          style={{ border: 'none', width: '100%', height: '60vh' }}
        ></iframe>

        <form method="dialog">
          <button
            onClick={() => handleSendData()}
            className="btn-primaty btn btn-success btn-lg btn-block text-white"
          >
            Ok, Quero aderir agora
          </button>
        </form>
      </div>
    </dialog>
    <input type="checkbox" id="minuta_modal" className="modal-toggle" />
  </>
)

export default ModalMinuta
